export const primaryColumnDefaults = {
  aggregate: (groupItems, groupValue) => groupValue,
  aggregateFormatter: (groupValue) => groupValue,
  primary: true,
  width: 200,
};
